export const services = [
  { id: 1, value: "police", text: "Police" },
  { id: 2, value: "ambulance", text: "Ambulance" },
  { id: 3, value: "fire", text: "Fire" },
];
